import { render, staticRenderFns } from "./BlogAdminPane.vue?vue&type=template&id=6671333c&scoped=true&"
import script from "./BlogAdminPane.vue?vue&type=script&lang=js&"
export * from "./BlogAdminPane.vue?vue&type=script&lang=js&"
import style0 from "./BlogAdminPane.vue?vue&type=style&index=0&id=6671333c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6671333c",
  null
  
)

export default component.exports